import { Root } from "@/models/roots/root.model";
import { createSlice } from "@reduxjs/toolkit";

const TundishHeatMetricInitialState: {
	tundishes: Root[];
} = {
	tundishes: [],
};

export const TundishHeatMetricReducer = createSlice({
	name: "__",
	initialState: TundishHeatMetricInitialState,
	reducers: {
		setTundishes(state, { payload }) {
			state.tundishes = payload;
		},
	},
});
